// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 2/13/2024 10:26:38 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { SecurityRoleTypeEnum } from '../../../appCore/models/schema/Schema';
import { SignupErrorCodeEnum } from '../functions/Functions';
import { Post } from '../../../httpClient';

export enum ClientInvitesPartnerEnum {
  invalidPartnerSecurityRoleType = 0,
  invalidClientCompanyId = 1,
  invalidPartnerCompanyId = 2,
  invitationToNonPartnerCompany = 3,
  selfInvitation = 4,
}

export enum MaintainClientPartnerInvitationEnum {
  bothAcceptAndDecline = 0,
  noneAcceptOrDecline = 1,
  invalidCompanyId = 2,
  invitationNotFound = 3,
}

export enum InvitePartnerUserEnum {
  invalidRoleType = 0,
  invalidClientCompanyId = 1,
  invitationToNonPartnerCompany = 2,
  selfInvitation = 3,
}

export enum PartnerInvitesClientEnum {
  invalidCompanyId = 0,
  maxTwoPartnersAssigned = 1,
  invalidPartnerSecurityRoleType = 2,
  invitationToPartnerCompany = 3,
  selfInvitation = 4,
}

export enum RevokePartnerAccessEnum {
  invalidCompanyId = 0,
  companiesNotLinked = 1,
}

export enum ValidateEmailEnum {
  invalidClientCompanyId = 0,
  emailExists = 1,
}

export enum PersistClientCompanyAdminListEnum {}

export enum GetUserListEnum {
  takeLessThen1 = 0,
  takeMoreThen100 = 1,
  skipLessThan0 = 2,
}

export enum GetUserListSortEnum {
  name = 0,
  email = 1,
  lastLoggedIn = 2,
  securityRoleType = 3,
}

export enum ModifyPartnerRoleEnum {
  invalidClientId = 0,
  invalidPartnerId = 1,
}

export enum DisconnectFromClientEnum {
  invalidClientId = 0,
  invalidPartnerId = 1,
}

export enum CompanyStatusTypeEnum {
  notSpecified = 0,
  waitingData = 1,
  pendingVerification = 2,
  active = 3,
  inactive = 4,
  closePending = 5,
  closed = 6,
  expired = 7,
}

export enum MaintainTwoStepApprovalEnum {
  invalidPartnerCompanyId = 0,
}

export interface ClientInvitesPartnerRequestInterface {
  clientCompanyId: number;
  partnerCompanyId: number;
  partnerSecurityRoleType: SecurityRoleTypeEnum;
  invitedByEmail: boolean;
  invitedByPartnerCompanyId: boolean;
  isInvitingNewPartner: boolean;
}

export interface ClientInvitesPartnerResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface MaintainClientPartnerInvitationRequestInterface {
  accept: boolean;
  decline: boolean;
  partnerSecurityRoleType: SecurityRoleTypeEnum;
  clientCompanyId?: number;
  partnerCompanyId?: number;
  invitationId?: number;
  partnerPaysFees: boolean;
}

export interface MaintainClientPartnerInvitationResponseInterface {
  subscriptionIsInTrial: boolean;
  previousBillingCycleStart?: string;
  previousBillingCycleEnd?: string;
  validationResults: ValidationResultsInterface;
}

export interface InvitePartnerUserRequestInterface {
  clientCompanyId: number;
  email: string;
  firstName: string;
  lastName: string;
  partnerSecurityRoleType: SecurityRoleTypeEnum;
}

export interface InvitePartnerUserResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface CompanyInterface {
  id: number;
  companyName: string;
  contactEmail: string;
  firstName: string;
  lastName: string;
  country: string;
  companyCode: string;
  securityRoleType: SecurityRoleTypeEnum;
}

export interface PartnerInvitesClientRequestInterface {
  clientCompanyId?: number;
  partnerSecurityRoleType: SecurityRoleTypeEnum;
  invitedByEmail: boolean;
  invitedByClientCompanyId: boolean;
  partnerPaysFees: boolean;
  subscriptionPlanId: number;
  partnerCompanyId: number;
  isInvitingNewClient: boolean;
  company: CompanyInterface;
}

export interface PartnerInvitesClientResponseInterface {
  clientCompanyId: number;
  signupErrorCode: SignupErrorCodeEnum;
  unknownErrorOccured: boolean;
  validationResults: ValidationResultsInterface;
}

export interface RevokePartnerAccessRequestInterface {
  partnerCompanyId: number;
  invitationId: number;
}

export interface RevokePartnerAccessResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ValidateEmailRequestInterface {
  emailAddress: string;
  clientCompanyId?: number;
}

export interface ValidateEmailResponseInterface {
  personId: number;
  userId?: number;
  validationResults: ValidationResultsInterface;
}

export interface GetInitialStateRequestInterface {
  clientCompanyId?: number;
}

export interface GetInitialStateResponseInterface {
  clientRequestList: Array<CompanyCardInterface>;
  onboardingInprogressList: Array<CompanyCardInterface>;
  verificationPendingList: Array<CompanyCardInterface>;
  validationResults: ValidationResultsInterface;
}

export interface CompanyCardInterface {
  id: number;
  name: string;
  companyStatusType: CompanyStatusTypeEnum;
}

export interface PersistClientCompanyAdminListRequestInterface {
  companyIdList: Array<number>;
  userIdList: Array<number>;
  securityRoleType: SecurityRoleTypeEnum;
  partnerId: number;
  assign: boolean;
  unassign: boolean;
}

export interface PersistClientCompanyAdminListResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetUserListRequestInterface {
  take: number;
  skip: number;
  clientId: number;
  securityRoleType: SecurityRoleTypeEnum;
  filterByEmail: boolean;
  emailContains: string;
  filterByName: boolean;
  nameContains: string;
  sortColumnType: GetUserListSortEnum;
  sortAscending: boolean;
  includeClientCount: boolean;
  partnerId: number;
}

export interface GetUserListResponseInterface {
  totalCount: number;
  userList: Array<UserInterface>;
  validationResults: ValidationResultsInterface;
}

export interface UserInterface {
  id: number;
  email: string;
  lastLogin?: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  companyId: number;
  personId: number;
  twoFactorEnabled: boolean;
  countryType: string;
  profileDocumentId?: number;
  securityRoleType: SecurityRoleTypeEnum;
}

export interface ModifyPartnerRoleRequestInterface {
  clientId: number;
  partnerId: number;
  securityRoleType: SecurityRoleTypeEnum;
}

export interface ModifyPartnerRoleResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface DisconnectFromClientRequestInterface {
  clientId: number;
  partnerId: number;
}

export interface DeleteInvitationRequestInterface {
  invitationId: number;
}

export interface DisconnectFromClientResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface VerifyCompanyInvitationRequestInterface {
  key: string;
  password: string;
}

export interface VerifyCompanyInvitationResponseInterface {
  resetPasswordKey: string;
  companyName: string;
  signupErrorCode: SignupErrorCodeEnum;
  unknownErrorOccured: boolean;
  validationResults: ValidationResultsInterface;
}

export interface GetCompanyInvitationRequestInterface {
  id: number;
}

export interface GetCompanyInvitationResponseInterface {
  companyInvitation: CompanyInvitationInterface;
  validationResults: ValidationResultsInterface;
}

export interface CompanyInvitationInterface {
  id: number;
  companyName: string;
  firstName: string;
  lastName: string;
  securityRoleType: SecurityRoleTypeEnum;
  contactEmail: string;
}

export interface RemindToSignupRequestInterface {
  clientCompanyId: number;
  partnerCompanyId: number;
}

export interface RemindToSignupResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface MaintainTwoStepApprovalRequestInterface {
  partnerCompanyId: number;
  clientCompanyIdList: Array<number>;
  enableForAllClients: boolean;
  turnOn: boolean;
}

export interface MaintainTwoStepApprovalResponseInterface {
  validationResults: ValidationResultsInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

export class CompanyLinkAccessService {
  clientInvitesPartner(request: ClientInvitesPartnerRequestInterface): Promise<ClientInvitesPartnerResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/clientInvitesPartner', request);
  }

  maintainClientPartnerInvitation(
    request: MaintainClientPartnerInvitationRequestInterface
  ): Promise<MaintainClientPartnerInvitationResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/maintainClientPartnerInvitation', request);
  }

  invitePartnerUser(request: InvitePartnerUserRequestInterface): Promise<InvitePartnerUserResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/invitePartnerUser', request);
  }

  partnerInvitesClient(request: PartnerInvitesClientRequestInterface): Promise<PartnerInvitesClientResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/partnerInvitesClient', request);
  }

  revokePartnerAccess(request: RevokePartnerAccessRequestInterface): Promise<RevokePartnerAccessResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/revokePartnerAccess', request);
  }

  validateEmail(request: ValidateEmailRequestInterface): Promise<ValidateEmailResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/validateEmail', request);
  }

  getInitialState(request: GetInitialStateRequestInterface): Promise<GetInitialStateResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/getInitialState', request);
  }

  persistClientCompanyAdminList(
    request: PersistClientCompanyAdminListRequestInterface
  ): Promise<PersistClientCompanyAdminListResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/persistClientCompanyAdminList', request);
  }

  getUserList(request: GetUserListRequestInterface): Promise<GetUserListResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/getUserList', request);
  }

  modifyPartnerRole(request: ModifyPartnerRoleRequestInterface): Promise<ModifyPartnerRoleResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/modifyPartnerRole', request);
  }

  disconnectFromClient(request: DisconnectFromClientRequestInterface): Promise<DisconnectFromClientResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/disconnectFromClient', request);
  }

  deleteCompanyInvitation(request: DeleteInvitationRequestInterface): Promise<any> {
    return Post('/FinanceCompanyLinkAccess/deleteCompanyInvitation', request);
  }

  verifyCompanyInvitation(
    request: VerifyCompanyInvitationRequestInterface
  ): Promise<VerifyCompanyInvitationResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/verifyCompanyInvitation', request);
  }

  getCompanyInvitation(request: GetCompanyInvitationRequestInterface): Promise<GetCompanyInvitationResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/getCompanyInvitation', request);
  }

  remindToSignup(request: RemindToSignupRequestInterface): Promise<RemindToSignupResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/remindToSignup', request);
  }

  maintainTwoStepApproval(
    request: MaintainTwoStepApprovalRequestInterface
  ): Promise<MaintainTwoStepApprovalResponseInterface> {
    return Post('/FinanceCompanyLinkAccess/maintainTwoStepApproval', request);
  }
}

export default new CompanyLinkAccessService();
